import type { EstadoVenta } from '@adelante/shared';

/**
 * Filtro de estado de venta para los reportes.
 *   - 'formalizadas'    = vendidas (formalizada o entregada)
 *   - 'no_formalizadas' = reservadas, disponibles o sin estado
 */
export type FiltroVenta = 'todas' | 'formalizadas' | 'no_formalizadas';

/** Formalizada/entregada = "vendida"; el resto = "no formalizada". */
export function esFormalizada(ev: EstadoVenta | null | undefined): boolean {
  return ev === 'formalizada' || ev === 'entregada';
}

/** ¿La obra (por su estado de venta) entra en el filtro elegido? */
export function coincideVenta(ev: EstadoVenta | null | undefined, filtro: FiltroVenta): boolean {
  if (filtro === 'todas') return true;
  return filtro === 'formalizadas' ? esFormalizada(ev) : !esFormalizada(ev);
}

export const FILTRO_VENTA_LABEL: Record<FiltroVenta, string> = {
  todas: 'Todas',
  formalizadas: 'Formalizadas',
  no_formalizadas: 'No formalizadas',
};
